<template>
  <div class="protocol login-protocol">
    <navigation>《及未科技用户服务协议》</navigation> 
    <nd-pdf title="《及未科技用户服务协议》" src="https://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/TMD/protocol/%E5%8F%8A%E6%9C%AA%E7%A7%91%E6%8A%80%E7%94%A8%E6%88%B7%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE.pdf"></nd-pdf>
  </div>
</template>

<script>

export default {
  name: 'vipProtocol',
  created () {
    this.$bus.$emit('ready')
  },
  beforeCreate () {
    window.location.href = 'https://download-cos.yofish.com/cooperator-shenghuozhibei/20230831154558902-1cd357b60.html'
  }
}

</script>

<style lang="less">
@import "../../assets/less/mixin.less";

    .login-protocol {
        background-color: white;
        
        .content {
            padding: 0 48px;
            .title {
                font-weight: bolder;
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
                margin-top: 10px;
            }
            .text {
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
            }
            .text:last-child {
                margin-bottom: 10px;
            }
            .underline {
                text-indent: 40px;
                font-weight: bold;
                text-decoration: underline;
            }
            .underline:last-child {
                margin-bottom: 10px;
            }
        }
    }
</style>
